export default __webpack_public_path__ + "1048fb6c6f27f47bf948fb31f29df26d.png";